function lowercaseAndShorten(lang) {
    return lang.split('-')[0].toLowerCase();
}

function normalizeLanguages(langs) {
    // Если langs массив берём основную часть каждого lang до '-', преобразуем в нижний регистр, потом убираем дубликаты и сортируем
    if (Array.isArray(langs)) {
        const lowercasedLangs = langs.map(lang => lowercaseAndShorten(lang));
        return [...new Set(lowercasedLangs)].sort();
    // Если langs строка берём основную часть до '-' и преобразуем в нижний регистр
    } else if (typeof langs === 'string') {
        return [lowercaseAndShorten(langs)];
    }
    // Если langs не массив и не строка возвращаем null
    return null;
}

export default normalizeLanguages;